(function () {
  'use strict';
  var cartState = null, busy = false, syncing = null;
  var storageKey = 'elite_removed_discount_codes';
  var trackedCodes = (new URL(window.location.href).searchParams.get('discount') || '').split(',').filter(Boolean);
  var removedCodes = [];
  try { removedCodes = JSON.parse(sessionStorage.getItem(storageKey) || '[]'); } catch (error) {}
  removedCodes = removedCodes.filter(function (code) { return !trackedCodes.some(function (entry) { return entry.toUpperCase() === code; }); });
  function persistChoice() { try { sessionStorage.setItem(storageKey, JSON.stringify(removedCodes)); } catch (error) {} }
  persistChoice();
  function getCodes(cart) {
    var result = [];
    var applications = (cart && cart.cart_level_discount_applications || []).slice();
    (cart && cart.items || []).forEach(function (item) { (item.line_level_discount_allocations || []).forEach(function (allocation) { applications.push(allocation.discount_application); }); });
    var confirmedCodes = (cart && cart.discount_codes || []).filter(function (entry) { return entry.applicable; }).map(function (entry) { return entry.code.toUpperCase(); });
    applications.forEach(function (entry) { if (entry && entry.type === 'discount_code') confirmedCodes.push(entry.title.toUpperCase()); });
    var previousRemovedCount = removedCodes.length;
    removedCodes = removedCodes.filter(function (code) { return !confirmedCodes.includes(code); });
    if (removedCodes.length !== previousRemovedCount) persistChoice();
    function add(code, applicable) {
      if (!code || removedCodes.includes(code.toUpperCase())) return;
      var existing = result.find(function (entry) { return entry.code.toUpperCase() === code.toUpperCase(); });
      if (existing) { if (applicable) existing.applicable = true; }
      else result.push({code:code, applicable:applicable});
    }
    (cart && cart.discount_codes || []).forEach(function (entry) { add(entry.code,entry.applicable); });
    applications.forEach(function (entry) { if (entry && entry.type === 'discount_code') add(entry.title,true); });
    document.querySelectorAll('[data-elite-cart-discounts]').forEach(function (container) {
      try { JSON.parse(container.dataset.appliedCodes || '[]').filter(Boolean).forEach(function (code) { add(code,true); }); } catch (error) {}
    });
    trackedCodes.forEach(function (code) { add(code,false); });
    return result;
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function request(url, body) {
    return fetch(root + url, {method:body ? 'POST' : 'GET', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:body ? JSON.stringify(body) : undefined}).then(function (response) {
      return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || data.message || ''); return data; });
    });
  }
  function feedback(container, message) {
    var el = container && container.querySelector('[data-elite-feedback]');
    if (el) {
      el.textContent = message; el.hidden = !message;
      if (container.matches('[data-elite-cart-discounts]')) container.hidden = !message;
    }
  }
  function renderDiscounts() {
    document.querySelectorAll('[data-elite-cart-discounts]').forEach(function (container) {
      var list = container.querySelector('[data-elite-discount-list]');
      if (list) list.replaceChildren();
      var message = container.querySelector('[data-elite-feedback]');
      container.hidden = !message || message.hidden;
    });
    document.querySelectorAll('[data-elite-remove-discount]').forEach(function (button) {
      button.disabled = busy;
    });
  }
  function refresh() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true,detail:{scrollToTop:false}})); }
  function sync() {
    if (syncing) return syncing;
    syncing = request('cart.js').then(function (cart) {
      cartState = cart;
      getCodes(cart);
      renderDiscounts();
      return cart;
    }).finally(function () { syncing = null; });
    return syncing;
  }
  document.addEventListener('click', function (event) {
    var carousel = event.target.closest('[data-elite-carousel]');
    if (carousel) {
      event.preventDefault();
      var track = carousel.closest('.elite-cart-suggestions').querySelector('.elite-cart-suggestions__list');
      track.scrollBy({left:Number(carousel.dataset.eliteCarousel)*track.clientWidth*.85,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      return;
    }
    var add = event.target.closest('[data-elite-add]');
    if (add) {
      event.preventDefault(); if (busy || add.disabled) return;
      var card = add.closest('[data-elite-quick-add]'), select = card.querySelector('[data-elite-variant]'), label = add.textContent;
      busy = true; add.disabled = true; add.textContent = card.dataset.adding; feedback(card,'');
      request('cart/add.js',{items:[{id:Number(select ? select.value : add.dataset.variantId),quantity:1}]}).then(function () {
        add.textContent = card.dataset.added;
        return sync().finally(function () { document.documentElement.dispatchEvent(new CustomEvent('product:added',{bubbles:true,detail:{quantity:1,button:add}})); });
      }).catch(function (error) { feedback(card,error.message || card.dataset.error); }).finally(function () { busy = false; add.disabled = false; if (add.isConnected) add.textContent = label; renderDiscounts(); });
      return;
    }
    var remove = event.target.closest('[data-elite-remove-discount]');
    if (!remove || busy) return;
    event.preventDefault();
    var scope = remove.closest('.mini-cart, [data-section-type="cart"]') || document;
    var container = scope.querySelector('[data-elite-cart-discounts]'), removed = remove.dataset.eliteRemoveDiscount;
    busy = true; renderDiscounts(); feedback(container,'');
    Promise.resolve(syncing).then(function () { return request('cart.js'); }).then(function (cart) {
      var codes = getCodes(cart).map(function (entry) { return entry.code; }).filter(function (code) { return code.toUpperCase() !== removed.toUpperCase(); });
      return request('cart/update.js',{discount:codes.join(',')});
    }).then(function (cart) {
      cartState = cart; removedCodes.push(removed.toUpperCase()); persistChoice();
      document.querySelectorAll('[data-elite-line-discount]').forEach(function (label) {
        if (label.dataset.eliteLineDiscount.toUpperCase() === removed.toUpperCase()) label.hidden = true;
      });
      trackedCodes = trackedCodes.filter(function (code) { return code.toUpperCase() !== removed.toUpperCase(); });
      var url = new URL(window.location.href), queryCodes = (url.searchParams.get('discount') || '').split(',').filter(function (code) { return code && code.toUpperCase() !== removed.toUpperCase(); });
      if (queryCodes.length) url.searchParams.set('discount',queryCodes.join(',')); else url.searchParams.delete('discount');
      window.history.replaceState({},'',url); busy = false; renderDiscounts(); refresh();
    }).catch(function (error) { feedback(container,error.message || (container && container.dataset.error)); }).finally(function () { busy = false; renderDiscounts(); });
  });
  function syncQuietly() { sync().catch(function () {}); }
  document.addEventListener('cart:rerendered',syncQuietly,true);
  document.addEventListener('product:added',syncQuietly);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',syncQuietly); else syncQuietly();
}());


